import { I as t } from "../../constants-DeVuDy8J.js";
import { createElementBlock as n, openBlock as l, normalizeClass as d, createElementVNode as r } from "vue";
import { _ as o } from "../../_plugin-vue_export-helper-CHgC5LLL.js";
const s = {
  name: "DtIconExternalLink",
  props: {
    /**
     * The size of the icon.
     * @values 100, 200, 300, 400, 500, 600, 700, 800
     */
    size: {
      type: String,
      default: "500",
      validator: (e) => Object.keys(t).includes(e)
    },
    /**
     * The label of the icon as read out by a screenreader. Leave this unset if your icon is purely presentational
     */
    ariaLabel: {
      type: String,
      default: void 0
    }
  },
  /**
  * @TODO: Remove this emit once the icons migration is complete,
  * they will no longer need this event.
  * */
  emits: ["loaded"],
  computed: {
    iconSizeClass() {
      return t[this.size];
    },
    ariaHidden() {
      return this.ariaLabel ? "false" : "true";
    },
    dataQA() {
      return this.$attrs["data-qa"] ?? "dt-icon";
    }
  },
  created() {
    this.$emit("loaded");
  }
}, c = ["aria-label", "data-qa", "aria-hidden"], _ = /* @__PURE__ */ r("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M2.5 3.5A.5.5 0 0 0 2 4v5.5a.5.5 0 0 0 .5.5H8a.5.5 0 0 0 .5-.5v-3a.5.5 0 0 1 1 0v3A1.5 1.5 0 0 1 8 11H2.5A1.5 1.5 0 0 1 1 9.5V4a1.5 1.5 0 0 1 1.5-1.5h3a.5.5 0 0 1 0 1h-3Z",
  fill: "currentColor"
}, null, -1), u = /* @__PURE__ */ r("path", {
  d: "M7 1.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-1 0V2.707L5.354 7.354a.5.5 0 1 1-.708-.708L9.293 2H7.5a.5.5 0 0 1-.5-.5Z",
  fill: "currentColor"
}, null, -1), h = [
  _,
  u
];
function m(e, f, i, p, v, a) {
  return l(), n("svg", {
    "aria-label": i.ariaLabel,
    class: d([a.iconSizeClass, "d-icon d-icon--external-link"]),
    "data-qa": a.dataQA,
    "aria-hidden": a.ariaHidden,
    role: "img",
    "data-name": "External Link",
    viewBox: "0 0 12 12",
    xmlns: "http://www.w3.org/2000/svg"
  }, h, 10, c);
}
const L = /* @__PURE__ */ o(s, [["render", m]]);
export {
  L as default
};
//# sourceMappingURL=external-link.js.map
